import { useEffect, useState } from "react";
import { Utilitaries } from "../../../../business";
import { GenericObject, InputInTableProps, RequestStatus } from "../../../types/common";
import {
    FormInputsObjectProps,
    FormInputsProps,
    FormRootElementAttributesProps,
    InputDependenceProps,
} from "../../../types/formTypes";
import { transformParams, urlAndParamsSplit } from "../../../utils/FormMapper/transformParams";
import { COMPONENT_TYPE } from "../../../utils/FormMapper/XMLInputType";
import {
    checkCanExecuteActionData,
    dataGridParamsDependencies,
    getDataSourceFromValues,
} from "../../../utils/functions";
import { api_fetch } from "../../../utils/HttpRequest/request";
import { downloadFile } from "../../../../components/util";

interface QueryParamsProps {
    accao?: string;
    query?: string;
    [key: string]: any;
}

interface FetchProps {
    endPoint: string;
    componentsProperties: FormInputsProps;
    state: FormInputsObjectProps;
    inputDependence?: InputDependenceProps;
    popup_params?: GenericObject;
    triggerDataGridData?: number;
    rootElementAttribute: FormRootElementAttributesProps;
    tableRow?: InputInTableProps;
}

export const useData = ({
    endPoint,
    componentsProperties,
    state,
    popup_params,
    triggerDataGridData,
    rootElementAttribute,
    tableRow,
}: FetchProps) => {
    const [data, setData] = useState<any[]>([]);
    const [dataGridCampos, setDataGridCampos] = useState<string>("");
    const [dataGridTipoCampos, setDataGridTipoCampos] = useState<string>("");
    const [status, setStatus] = useState<RequestStatus>("IDLE");

    const { params, queryName } = urlAndParamsSplit(componentsProperties.data_query, null);
    const _transformParams = transformParams({ params, formData: state });

    let newParams: QueryParamsProps = {
        ..._transformParams,
    };
    if (queryName) {
        newParams = {
            ...popup_params,
            ...newParams,
            query: queryName,
        };
    }

    //dependencias da datagrid

    // dataGridDependenciesValues;

    useEffect(() => {
        let cancelRequest = false;

        if (!checkCanExecuteActionData(componentsProperties, state, triggerDataGridData || 0, rootElementAttribute)) {
            if (cancelRequest) return;

            if (componentsProperties.values) {
                const _data = getDataSourceFromValues(componentsProperties.values);
                setData(_data);
            }

            return;
        }
        if (!endPoint) return;

        // eslint-disable-next-line react-hooks/exhaustive-deps
        newParams = {
            [`id_${componentsProperties.form_key}`]: state[`id_${componentsProperties.form_key}`]?.value || 0,
            ...newParams,
            ...dataGridParamsDependencies({ componentProperties: componentsProperties, state }),
        };

        const formData = new FormData();
        Object.entries(newParams).forEach(([key, value]) => {
            if (!Utilitaries.isEmpty(value)) {
                formData.append(key, value);
            }
        });

        if (componentsProperties.key === "lista_despesas" && Utilitaries.isEmpty(newParams.lista_procs)) {
            formData.append("lista_procs", "''");
        }

        formData.append(
            "_valor_campo_",
            Utilitaries.isEmpty(componentsProperties.value)
                ? tableRow
                    ? tableRow?.row_data?.[componentsProperties.key]
                    : ""
                : componentsProperties.value
        );

        if (!queryName && ["execQuery.php", "geredatagrid.php"].includes(endPoint)) {
            return;
        }

        const fetchData = async () => {
            setStatus("FETCHING");

            try {
                const { response } = await api_fetch({
                    endPoint: `Gestor/${endPoint}`,
                    method: "POST",
                    body: formData,
                });

                if (cancelRequest) return;

                if (
                    componentsProperties.type === COMPONENT_TYPE.DATAGRID ||
                    componentsProperties.type === COMPONENT_TYPE.DYNAMIC_DATAGRID
                ) {
                    setData(Utilitaries.toArray(response?.linha));
                    setDataGridCampos(response?.["@attributes"]?.nomes_campos);
                    setDataGridTipoCampos(response?.["@attributes"]?.tipo_campos);
                } else {
                    setData(response.result);
                }

                setStatus("FETCHED");
            } catch (error) {
                if (cancelRequest) return;
                setStatus("FETCH_ERROR");
            }
        };

        fetchData();

        return function cleanup() {
            cancelRequest = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerDataGridData]);

    function exportList(fileType = "pdf") {
        let campos = "";
        const listOfFields = dataGridCampos.split(";").filter((field) => !Utilitaries.isEmpty(field));
        const listOfTypeFields = dataGridTipoCampos.split(";");
        Object.keys(componentsProperties).forEach((_key) => {
            const index = listOfFields.indexOf(_key);
            if (typeof componentsProperties[_key] === "object" && index !== -1) {
                const fieldType = listOfTypeFields[index]
                const fieldSize = ['int4', 'numeric', 'date'].includes(fieldType) ? 3 : 6
                campos = `${campos}${_key}:${fieldSize}:${
                    componentsProperties[_key]?.label || Utilitaries.toPascalCase(componentsProperties?.key, true)
                };`;
            }
        });

        const params = {
            ...popup_params,
            ...newParams,
            accao: "lista",
            lista: queryName,
            saida: fileType,
            titulo: rootElementAttribute.title,
            campos,
            downloadInBrowser: true,
            ...dataGridParamsDependencies({ componentProperties: componentsProperties, state }),
        };

        downloadFile("/geredatagrid.php", params);
    }

    // ...dataGridDependenciesValues({ componentProperties: componentsProperties, state })
    return { status, data, exportList };
};
